import { BoundToggleButtonGroup } from "lib/@components/binding/bound-components.js"
import { Box, Stack, ToggleButton } from "@mui/material"
import Iconify from "minimals-template/components/Iconify.js"

export function MappingConfidenceThreshold() {
    return (
        <>
            <BoundToggleButtonGroup
                size="small"
                fullWidth
                field="mappingRule"
                defaultValue="strict"
                data-cy="mapping-rule"
            >
                <ToggleButton value="strict" data-cy="mapping-rule-strict">
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Iconify icon="mdi:shield" />
                        <Box>Strict Auto-Selection</Box>
                    </Stack>
                </ToggleButton>
                <ToggleButton value="moderate" data-cy="mapping-rule-moderate">
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Iconify icon="mdi:justice" />
                        <Box>Moderate Auto-Selection</Box>
                    </Stack>
                </ToggleButton>
                <ToggleButton value="relaxed" data-cy="mapping-rule-relaxed">
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Iconify icon="ph:list-magnifying-glass" />
                        <Box>Relaxed Auto-Selection</Box>
                    </Stack>
                </ToggleButton>
            </BoundToggleButtonGroup>
        </>
    )
}
